"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faSortDown_1 = require("@fortawesome/pro-solid-svg-icons/faSortDown");
var faSortUp_1 = require("@fortawesome/pro-solid-svg-icons/faSortUp");
var styles_1 = require("@mui/material/styles");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var Icon_1 = __importDefault(require("atomicComponents/atoms/Icons/Icon"));
var general_1 = require("utils/general");
var StyledButton = (0, styles_1.styled)(TextButton_1.default, { shouldForwardProp: (0, general_1.omitProps)('isOpen', 'withSort', 'showSortOnHover') })(function (_a) {
    var theme = _a.theme, isOpen = _a.isOpen, _b = _a.showSortOnHover, showSortOnHover = _b === void 0 ? false : _b;
    return (__assign({ lineHeight: '20px', '&.MuiButton-textNeutral': { color: theme.palette.riverstone }, '& .MuiButton-endIcon>*:nth-of-type(1)': {
            fontSize: theme.typography.body2.fontSize,
        }, borderColor: isOpen ? 'initial' : 'transparent', ':hover': {
            borderColor: 'initial',
        } }, showSortOnHover && {
        '&:hover&:not(:disabled) .MuiButton-endIcon': { opacity: 1 },
        '& .MuiButton-endIcon': { opacity: isOpen ? 1 : 0 },
    }));
});
var DropdownButton = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, _b = _a.withSort, withSort = _b === void 0 ? true : _b, rest = __rest(_a, ["children", "isOpen", "withSort"]);
    return ((0, jsx_runtime_1.jsx)(StyledButton, __assign({ color: "neutral", isOpen: isOpen }, rest, { endIcon: withSort && (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: isOpen ? faSortUp_1.faSortUp : faSortDown_1.faSortDown }) }, { children: children })));
};
exports.default = DropdownButton;
